<template>
  <div class='container'>
    <!-- Keyword description modal -->
    <modal v-show="modalVisible" @close="closeModal">
      <div id='keywordBody' slot='body'></div>
    </modal>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq12' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;'>
          <h3 class='textSectionQuestion' v-html="q2_4"></h3>
        </legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion12' name='medicalQuestion12' id='mq12y' aria-labelledby='lbl_mq12y' type='radio' value='true'/>
            <label id='lbl_mq12y' for='mq12y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion12' name='medicalQuestion12' id='mq12n' aria-labelledby='lbl_mq12n' type='radio' value='false'/>
            <label id='lbl_mq12n' for='mq12n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <h3 class="textSectionTitle" v-html="q2_5"></h3>
    <div class='row questionnaireRow'>       
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq13' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5a'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion13' name='medicalQuestion13' id='mq13y' aria-labelledby='lbl_mq13y' type='radio' value='true'/>
            <label id='lbl_mq13y' for='mq13y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion13' name='medicalQuestion13' id='mq13n' aria-labelledby='lbl_mq13n' type='radio' value='false'/>
            <label id='lbl_mq13n' for='mq13n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>  
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq14' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5b'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion14' name='medicalQuestion14' id='mq14y' aria-labelledby='lbl_mq14y' type='radio' value='true'/>
            <label id='lbl_mq14y' for='mq14y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion14' name='medicalQuestion14' id='mq14n' aria-labelledby='lbl_mq14n' type='radio' value='false'/>
            <label id='lbl_mq14n' for='mq14n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq15' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5c'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion15' name='medicalQuestion15' id='mq15y' aria-labelledby='lbl_mq15y' type='radio' value='true'/>
            <label id='lbl_mq15y' for='mq15y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion15' name='medicalQuestion15' id='mq15n' aria-labelledby='lbl_mq15n' type='radio' value='false'/>
            <label id='lbl_mq15n' for='mq15n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq16' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5d'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion16' name='medicalQuestion16' id='mq16y' aria-labelledby='lbl_mq16y' type='radio' value='true'/>
            <label id='lbl_mq16y' for='mq16y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion16' name='medicalQuestion16' id='mq16n' aria-labelledby='lbl_mq16n' type='radio' value='false'/>
            <label id='lbl_mq16n' for='mq16n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq17' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5e'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion17' name='medicalQuestion17' id='mq17y' aria-labelledby='lbl_mq17y' type='radio' value='true'/>
            <label id='lbl_mq17y' for='mq17y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion17' name='medicalQuestion17' id='mq17n' aria-labelledby='lbl_mq17n' type='radio' value='false'/>
            <label id='lbl_mq17n' for='mq17n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq18' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5f'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion18' name='medicalQuestion18' id='mq18y' aria-labelledby='lbl_mq18y' type='radio' value='true'/>
            <label id='lbl_mq18y' for='mq18y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion18' name='medicalQuestion18' id='mq18n' aria-labelledby='lbl_mq18n' type='radio' value='false'/>
            <label id='lbl_mq18n' for='mq18n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq19' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5g'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion19' name='medicalQuestion19' id='mq19y' aria-labelledby='lbl_mq19y' type='radio' value='true'/>
            <label id='lbl_mq19y' for='mq19y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion19' name='medicalQuestion19' id='mq19n' aria-labelledby='lbl_mq19n' type='radio' value='false'/>
            <label id='lbl_mq19n' for='mq19n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq20' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5h'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion20' name='medicalQuestion20' id='mq20y' aria-labelledby='lbl_mq20y' type='radio' value='true'/>
            <label id='lbl_mq20y' for='mq20y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion20' name='medicalQuestion20' id='mq20n' aria-labelledby='lbl_mq20n' type='radio' value='false'/>
            <label id='lbl_mq20n' for='mq20n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq21' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5i'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion21' name='medicalQuestion21' id='mq21y' aria-labelledby='lbl_mq21y' type='radio' value='true'/>
            <label id='lbl_mq21y' for='mq21y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion21' name='medicalQuestion21' id='mq21n' aria-labelledby='lbl_mq21n' type='radio' value='false'/>
            <label id='lbl_mq21n' for='mq21n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq22' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5j'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion22' name='medicalQuestion22' id='mq22y' aria-labelledby='lbl_mq22y' type='radio' value='true'/>
            <label id='lbl_mq22y' for='mq22y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion22' name='medicalQuestion22' id='mq22n' aria-labelledby='lbl_mq22n' type='radio' value='false'/>
            <label id='lbl_mq22n' for='mq22n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq23' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5k'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion23' name='medicalQuestion23' id='mq23y' aria-labelledby='lbl_mq23y' type='radio' value='true'/>
            <label id='lbl_mq23y' for='mq23y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion23' name='medicalQuestion23' id='mq23n' aria-labelledby='lbl_mq23n' type='radio' value='false'/>
            <label id='lbl_mq23n' for='mq23n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq24' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;' v-html='q2_5l'></legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion24' name='medicalQuestion24' id='mq24y' aria-labelledby='lbl_mq24y' type='radio' value='true'/>
            <label id='lbl_mq24y' for='mq24y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion24' name='medicalQuestion24' id='mq24n' aria-labelledby='lbl_mq24n' type='radio' value='false'/>
            <label id='lbl_mq24n' for='mq24n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
        <legend id='lbl_mq25' class='radioLegend' style='margin-left:15px; font-weight: 600; color: #333;'>
          <h3 class="textSectionQuestion" v-html="q2_6"></h3>
        </legend>
        <div class='col' style='padding-top:15px;padding-left:15px;padding-right:0px;'>
          <span class='radio'>
            <input v-model='medicalQuestion25' name='medicalQuestion25' id='mq25y' aria-labelledby='lbl_mq25y' type='radio' value='true'/>
            <label id='lbl_mq25y' for='mq25y' class='radio-label'>{{$t('text.yes')}}</label>
          </span>
          <span class='radio'>
            <input v-model='medicalQuestion25' name='medicalQuestion25' id='mq25n' aria-labelledby='lbl_mq25n' type='radio' value='false'/>
            <label id='lbl_mq25n' for='mq25n' class='radio-label'>{{$t('text.no')}}</label>
          </span>
        </div>
      </fieldset>
    </div>
    <div class='row questionnaireRow' style='margin-top:25px;'>
      <div class='col-auto'>
        <input v-model="confirmMedical" aria-required="true" class='regular-checkbox' type='checkbox' id='confirmMedical' name="confirmMedical" style='margin-left:7px;'>
      </div>
      <div class='col'>
        <label for='confirmMedical' class='checkbox-label'>
          {{$t('text.page7_confirm')}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { addNavProceedCheck } from "../utils/navProceed.js";
  import { initKeywords } from "../utils/keywords.js";
  import modal from "../components/Modal.vue";
  import { validationRules } from "../utils/validation_rules.js";
  import { validateForm, validateField } from "../utils/validation.js";

  export default {
    components: {
      modal,
    },
    data() {
      return {
        q2_4: "4. "+this.$store.state.survey.Steps[1].Questions[3].Text,
        q2_5: "5. "+this.$store.state.survey.Steps[1].Questions[4].Text,
        q2_5a: "a) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[0].Text,
        q2_5b: "b) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[1].Text,
        q2_5c: "c) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[2].Text,
        q2_5d: "d) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[3].Text,
        q2_5e: "e) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[4].Text,
        q2_5f: "f) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[5].Text,
        q2_5g: "g) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[6].Text,
        q2_5h: "h) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[7].Text,
        q2_5i: "i) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[8].Text,
        q2_5j: "j) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[9].Text,
        q2_5k: "k) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[10].Text,
        q2_5l: "l) "+this.$store.state.survey.Steps[1].Questions[4].SubQuestions[11].Text,
        q2_6: "6. "+this.$store.state.survey.Steps[2].Questions[0].Text,
        modalVisible: false
      }
    },
   computed: {
      medicalQuestion12: {
        get() {
          return this.$store.state.medicalQuestion12;
        },
        set() {
          validateField(mq12y, true, validationRules());
        }
      },
      medicalQuestion13: {
        get() {
          return this.$store.state.medicalQuestion13;
        },
        set() {
          validateField(mq13y, true, validationRules());
        }
      },
      medicalQuestion14: {
        get() {
          return this.$store.state.medicalQuestion14;
        },
        set() {
          validateField(mq14y, true, validationRules());
        }
      },
      medicalQuestion15: {
        get() {
          return this.$store.state.medicalQuestion15;
        },
        set() {
          validateField(mq15y, true, validationRules());
        }
      },
      medicalQuestion16: {
        get() {
          return this.$store.state.medicalQuestion16;
        },
        set() {
          validateField(mq16y, true, validationRules());
        }
      },
      medicalQuestion17: {
        get() {
          return this.$store.state.medicalQuestion17;
        },
        set() {
          validateField(mq17y, true, validationRules());
        }
      },
      medicalQuestion18: {
        get() {
          return this.$store.state.medicalQuestion18;
        },
        set() {
          validateField(mq18y, true, validationRules());
        }
      },
      medicalQuestion19: {
        get() {
          return this.$store.state.medicalQuestion19;
        },
        set() {
          validateField(mq19y, true, validationRules());
        }
      },
      medicalQuestion20: {
        get() {
          return this.$store.state.medicalQuestion20;
        },
        set() {
          validateField(mq20y, true, validationRules());
        }
      },
      medicalQuestion21: {
        get() {
          return this.$store.state.medicalQuestion21;
        },
        set() {
          validateField(mq21y, true, validationRules());
        }
      },
      medicalQuestion22: {
        get() {
          return this.$store.state.medicalQuestion22;
        },
        set() {
          validateField(mq22y, true, validationRules());
        }
      },
      medicalQuestion23: {
        get() {
          return this.$store.state.medicalQuestion23;
        },
        set() {
          validateField(mq23y, true, validationRules());
        }
      },
      medicalQuestion24: {
        get() {
          return this.$store.state.medicalQuestion24;
        },
        set() {
          validateField(mq24y, true, validationRules());
        }
      },
      medicalQuestion25: {
        get() {
          return this.$store.state.medicalQuestion25;
        },
        set() {
          validateField(mq25y, true, validationRules());
        }
      },
      confirmMedical: {
        get() {
          return this.$store.state.confirmMedical;
        },
        set(newValue) {
          validateField(document.getElementById("confirmMedical"), newValue, validationRules());
        }
      },
    },
    methods: {
      closeModal(){
        this.modalVisible=false;
      }
    },
    mounted() {
      // Clear appended text from Quote page title;
      document.getElementById("stepTitleAppend").innerHTML="";

      // If this session already has a policy number, reset the session
      if(this.$store.state.policyNumber!==""){location.reload();}
      
      // Focus stepTitle for accessibility.
      this.$nextTick( () => {
        document.getElementById("stepTitle").focus();
      });

      initKeywords(this);

      // Check if Next button should be enabled or disabled.
      const targets = [
        document.getElementById("mq12y"),
        document.getElementById("mq13y"),
        document.getElementById("mq14y"),
        document.getElementById("mq15y"),
        document.getElementById("mq16y"),
        document.getElementById("mq17y"),
        document.getElementById("mq18y"),
        document.getElementById("mq19y"),
        document.getElementById("mq20y"),
        document.getElementById("mq21y"),
        document.getElementById("mq22y"),
        document.getElementById("mq23y"),
        document.getElementById("mq24y"),
        document.getElementById("mq25y"),
        document.getElementById("confirmMedical")
      ];
      this.$nextTick( () => {
        addNavProceedCheck(targets);
      });
    },
  };
</script>
